module.exports = "/shared/img/angle-arrow-down.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/angle-arrow-down.svg
// module id = 78
// module chunks = 13